import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IInvoice } from "../models/invoice/IInvoice";
import { DefaultResponseWithData } from "../models/system";

export default function useInvoiceSingle(invoiceId: string | undefined) {
  const { get } = useApiHelper();

  const invoice = useQuery({
    queryKey: ["invoices", invoiceId],
    queryFn: () =>
      get<DefaultResponseWithData<IInvoice>>(`/invoice/${invoiceId}`),
    enabled: Boolean(invoiceId),
  });

  return { invoice };
}
